import Rollbar from 'rollbar';

import { isProduction } from '../env';

import type { ProviderProps } from '@rollbar/react';

const baseConfig = {
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: isProduction(),
  environment: process.env.NODE_ENV,
  payload: {
    client: {
      javascript: {
        code_version: '1.0.0',
        source_map_enabled: true,
      },
    },
  },
};

const rollbarConfig: ProviderProps['config'] = {
  accessToken: process.env.NEXT_PUBLIC_ROLLBAR_TOKEN,
  ...baseConfig,
};

const rollbarClient = new Rollbar(rollbarConfig);

export default rollbarClient;
